import {
  SET_USER_PROFILE,
  IS_REQUESTING,
  UPDATE_USER_NAME_AND_GENDER,
  SET_REFERRALS_DATA,
  UPDATE_BABY_DOB,
  CLEAR_USER_PROFILE,
} from "./constants";
import { CLEAR_SUBSCRIPTION_DATA } from "../Subscription/constants";

import { API_URLS } from "../../configs/api";
import { httpPost } from "../../utils/http";
import { showSuccessMsg, showErrorMsg } from "../../utils/notifications";
import {
  setUserSession,
  getUserSession,
  clearUserSession,
} from "../../utils/localStorage";
import { navigate } from "gatsby";
import analytics from "../../utils/analytics";
import { auth, signOut } from "../../utils/firebase";

/**
 * Login user
 *
 */
export const loginUser = (idToken, referral_code) => async (dispatch) => {
  dispatch({ type: IS_REQUESTING, data: true });
  try {
    let payload_data = {
      idToken,
    };

    if (referral_code) {
      payload_data["referral_code"] = referral_code;
    }
    const response = await httpPost(API_URLS.LOGIN, payload_data);

    if (response.status) {
      dispatch({ type: SET_USER_PROFILE, data: response.data });

      // set session in local storage
      setUserSession(response.data.session_token);
      try {
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new CustomEvent('AUTH_STATE_CHANGED', { detail: { isAuthenticated: true } }));
        }
      } catch (_) {}

      // Identify user in Mixpanel and set initial people properties
      try {
        analytics.identify(response.data.user_id, {
          user_name: response.data.user_name,
          email: response.data.email,
          phone: response.data.phone,
          gender: response.data.gender,
          signup_date: response.data.signup_date || new Date().toISOString(),
          platform: 'web'
        });
      } catch (err) {}

      // GA4: set user_id and emit auth event (sign_up or login)
      try {
        // Attach user_id to GA4 config for subsequent hits
        if (typeof window !== 'undefined' && window.gtag) {
          window.gtag('config', 'G-VSSESS01KJ', { user_id: response.data.user_id });

          const authMethod = response.data.auth_provider || (response.data.email ? 'google' : 'phone_otp');
          const isNew = response.data.new_user_flag === true;
          const eventName = isNew ? 'new_user_1' : 'login_1';
          const params = isNew ? { method: authMethod } : { method: authMethod };
          window.gtag('event', eventName, params);
        }
      } catch (err) {}

      if (response.data.referrer_user_name) {
        showSuccessMsg(
          `Hi; You were referred by ${response.data.referrer_user_name}! Welcome to Pukaar!`
        );
      }

      if (response.data.new_user_flag === true) {
        navigate("/enter-name");
      } else {
        navigate("/");
      }
    } else {
      showErrorMsg(response.message);
    }
  } catch (e) {}

  // end loading
  dispatch({ type: IS_REQUESTING, data: false });
};

/**
 * Login user
 *
 */
export const loginReviewUser = () => async (dispatch) => {
  // set session in local storage
  setUserSession(
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX3BpZCI6MTksInVzZXJfaWQiOiIyZjkzNjAxNC03YTIzLTQ1NDItOWNhOS05NWJmNTE0N2QwOGQiLCJjdXJyZW50X3RpbWUiOiIyMDI1LTA1LTIzIDE3OjExOjAzLjY1MTk2MyJ9.eKTV-YPkBpgCABAn4T6LDOxCUjSXl5wxgstwKP5-tjY"
  );

  dispatch({
    type: SET_USER_PROFILE,
    data: {
      baby_details: {
        baby_id: 19,
        date_of_birth: "2024-11-08",
        name: "Baby 1",
      },
      email: "puneet.pilania@prakarann.com",
      gender: null,
      phone: null,
      referral_code: "23456789",
      session_token: null,
      user_id: "2f936014-7a23-4542-9ca9-95bf5147d08d",
      user_name: "Puneet Pilania",
    },
  });
  navigate("/");
};

/**
 * verify token
 *
 */
export const verifyToken = () => async (dispatch) => {
  try {
    const session = getUserSession();
    if (!session) {
      // Guest mode: no token present, do not redirect
      return;
    }

    let payload_data = { session_token: session };

    const response = await httpPost(API_URLS.VERIFY_TOKEN, payload_data);

    if (response.status) {
      dispatch({ type: SET_USER_PROFILE, data: response.data });

      // Ensure Mixpanel has the identified user on refresh/new tab
      try {
        analytics.identify(response.data.user_id, {
          user_name: response.data.user_name,
          email: response.data.email,
          phone: response.data.phone,
          gender: response.data.gender,
          platform: 'web'
        });
      } catch (err) {}
    } else {
      showErrorMsg(response.message);
      clearUserSession();
      // Stay in guest mode instead of redirecting
    }
  } catch (e) {
    clearUserSession();
    // Stay in guest mode instead of redirecting
  }
};

/**
 * verify token
 *
 */
export const updateUserInfo = (user_name, gender) => async (dispatch) => {
  try {
    let payload_data = {
      user_name,
      gender,
    };

    const response = await httpPost(API_URLS.UPDATE_USER_INFO, payload_data);

    if (response.status) {
      dispatch({ type: UPDATE_USER_NAME_AND_GENDER, data: payload_data });

      // Update Mixpanel people properties to keep in sync
      try {
        analytics.setUserProperty({
          user_name,
          gender,
        });
      } catch (err) {}
    } else {
      showErrorMsg(response.message);
    }
  } catch (e) {}
};

/**
 * verify token
 *
 */
export const updateBabyInfo = (date_of_birth, baby_id) => async (dispatch) => {
  try {
    let payload_data = {
      date_of_birth,
      baby_id,
    };

    const response = await httpPost(API_URLS.UPDATE_BABY_INFO, payload_data);

    if (response.status) {
      dispatch({ type: UPDATE_BABY_DOB, data: payload_data });
    } else {
      showErrorMsg(response.message);
    }
  } catch (e) {}
};

/**
 * verify token
 *
 */
export const successfullReferralFetched = () => async (dispatch) => {
  try {
    const response = await httpPost(API_URLS.FETCH_SUCCESSFULL_REFERRALS);

    if (response.status) {
      dispatch({ type: SET_REFERRALS_DATA, data: response.data });
    } else {
      showErrorMsg(response.message);
    }
  } catch (e) {}
};

/**
 * Logout user
 *
 */
export const logout = () => async (dispatch) => {
  // Notify mobile app if inside React Native WebView
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({
      type: 'LOGOUT',
      data: {}
    }));
  }

  try {
    // Attempt Firebase signOut
    await signOut(auth);

    // Track successful logout
    analytics.trackPlatformEvent('LOGOUT_SUCCESS', {
      method: 'firebase_signout',
      user_id: 'anonymous'
    });
  } catch (error) {
    // Track failed logout
    analytics.trackPlatformEvent('LOGOUT_FAILED', {
      method: 'firebase_signout',
      error_code: error?.code || 'unknown',
      error_message: error?.message || 'Unknown error'
    });
  } finally {
    // Reset Mixpanel identity and properties if available
    try { analytics.reset(); } catch (err) {}

    // Clear both web and mobile auth state regardless
    clearUserSession();
    localStorage.removeItem('userToken');
    localStorage.removeItem('isAuthenticated');
    try { dispatch({ type: CLEAR_USER_PROFILE }); } catch (_) {}
    try { dispatch({ type: CLEAR_SUBSCRIPTION_DATA }); } catch (_) {}
    try {
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('AUTH_STATE_CHANGED', { detail: { isAuthenticated: false } }));
      }
    } catch (_) {}
    // Redirect to home; allow guest mode instead of forcing login page
    navigate("/");
  }
};
